import React from 'react'
import PropTypes from 'prop-types'

import MarkJellyfishV2ColorImage from '../assets/mark-jellyfish-v2-color.png'

const SlackInstall = ({ notInstalled }) => (

        <div className="container align-items-center">
            <div className="row">&nbsp;</div>
            <div className="row">&nbsp;</div>
            <div className="justify-content-center row ">
                <div className="col-sm-9 col-md-6">
                    <div className="card-group">
                        <div className="py-3 card">

                            {notInstalled && (
                                <div className="alert alert-danger mx-3 text-center text-danger">
                                    <div><strong>Jellyfish Not Installed</strong></div>
                                    <div><em>please click <u>Add to Slack</u> to continue</em></div>
                                </div>
                            )}

                            <div className="text-center card-body">

                                <div>
                                    <img alt="logo" className="d-md-down-none" src={MarkJellyfishV2ColorImage} height="140" width="140"/>

                                    <div className="py-4"><h3>Install the Jellyfish</h3></div>

                                    <a href="/slack/oauth/link/">
                                        <img
                                            alt="Add to Slack"
                                            height="40"
                                            width="139"
                                            src="https://platform.slack-edge.com/img/add_to_slack.png"
                                            srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
                                        />
                                    </a>
                                    <div>&nbsp;</div>
                                </div>
                                {/*<div className="mt-4 text-muted">Need help? hello@jellyfish.chat</div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
)

SlackInstall.propTypes = {
  oauthDenied: PropTypes.bool,
}

export default SlackInstall



// WEBPACK FOOTER //
// ./src/components/SlackInstall.jsx